export enum ProviderSubType {
    ClientIntegration = 'client_integration',
    DataProvider = 'data_provider'
}

export interface Provider {
    id: number
    name: string
    subtype: ProviderSubType
}

export enum ProviderId {
    Provider_1 = 1,
    Provider_74 = 74,
    Provider_119 = 119,
    Provider_128 = 128
}
